"use client";
import {NeoBreadcrumb, NeoHeader} from "@/components/shared";
import {useNeoContext} from "@/context/neo/neo.context";
import {useState} from "react";
import ExpenseWidget from "./widgets/Widget-expense";
import FuelWidget from "./widgets/Widget-fuel";
import ServiceWidget from "./widgets/Widget-service";
import VendorWidget from "./widgets/Widget-vendor";

export const NeoFleet: React.FC = () => {
  const breadCrumb = [
    {
      link: "/operations",
      label: "More"
    },
    {
      link: "/operations?tabid=settings",
      label: "Settings"
    },
    {
      link: "",
      label: "Expense Settings"
    }
  ];

  const [loading, setLoading] = useState(false);
  const {filterContext} = useNeoContext();
  const [vendordatas, setVendorDatas] = useState([]);
  const [fueldatas, setFuelDatas] = useState([]);
  const [expensedatas, setExpenseDatas] = useState([]);
  const [servicedatas, setServiceDatas] = useState([]);

  const openPopup = () => {
    alert();
  };
  return (
    <>
      <div className="flex min-h-[calc(100vh-63px)] w-full flex-col p-5">
        <div className="mb-2 flex-row">
          <NeoHeader message="Expense Settings"></NeoHeader>
        </div>
        <div className="mb-4 flex-row">
          <NeoBreadcrumb menus={breadCrumb}></NeoBreadcrumb>
        </div>
        <div className="grid gap-1 sm:grid-cols-1 md:grid-cols-1 lg:grid-cols-2">
          <VendorWidget />
          <FuelWidget />
          <ExpenseWidget />
          <ServiceWidget />
        </div>
      </div>
    </>
  );
};
